import request from '../utils/request';

export const validatePostcode = async (postcode: string) => {
  try {
    const {
      data: { isValid }
    } = (await request('/api/tree-collection/validate-postcode', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        postcode
      })
    })) as { data: { isValid: boolean } };

    return isValid;
  } catch (error) {
    throw new Error(error);
  }
};
